import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-organi-direttivi',
	templateUrl: './organi-direttivi.component.html',
	styleUrls: ['./organi-direttivi.component.css']
})
export class OrganiDirettiviComponent implements OnInit {

	constructor() { }

	ngOnInit(): void {
	}

}
